<template>
  <footer class="app-footer">
    <div class="container app-footer-container">
      <div class="app-footer__col">
        <ul class="app-footer__navigation">
          <li class="app-footer__list-item">
            <a
              href="https://fenixedu.org"
              rel="noreferrer"
              target="_blank"
            >
              Powered by FenixEdu&trade;
            </a>
          </li>
          <!-- <li
            v-for="(link, index) in configuration.footerLinks"
            :key="index"
            class="app-footer__list-item"
          >
            <a
              :href="link.url"
              target="_blank"
              rel="noreferrer"
            >
              {{ $t(link.translationKey) }}
            </a>
          </li> -->
        </ul>
        <p class="app-footer__copyright">
          {{ getCopyrightYear(2022) }} ©
          <a
            rel="noreferrer"
            target="_blank"
            href="tecnico.ulisboa.pt"
          >
            {{ $t('footer.copyright') }}
          </a>
        </p>
      </div>
      <!-- <div class="app-footer__col">
        <span class="h6 app-footer__logos-title">
          {{ $t('footer.cofinanced.title') }}
        </span>
        <ul class="app-footer__logos-list">
          <li class="app-footer__logo-item">
            <img
              width="151"
              height="63"
              src="@/assets/images/compete-2020-logo.png"
              :alt="$t('footer.cofinanced.alt.attribution', { name: 'Compete 2020' })"
            >
          </li>
          <li class="app-footer__logo-item">
            <img
              width="151"
              height="63"
              src="@/assets/images/portugal-2020-logo.png"
              :alt="$t('footer.cofinanced.alt.attribution', { name: 'Portugal 2020' })"
            >
          </li>
          <li class="app-footer__logo-item">
            <img
              width="151"
              height="63"
              src="@/assets/images/eu-social-fund-logo.png"
              :alt="$t('footer.cofinanced.alt.attribution', { name: 'EU Social Fund' })"
            >
          </li>
        </ul>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    getCopyrightYear (startYear) {
      if (new Date().getFullYear() > startYear) {
        return `${startYear}-${new Date().getFullYear()}`
      } else {
        return startYear
      }
    }
  }
}
</script>

<style lang="scss">
@use "sass:color";
@import "@/assets/scss/variables";

.app-footer {
  background-color: white;
  box-shadow: 0 -0.0625rem 0 0 color.change($dark, $alpha: 0.1);
  font-size: 0.875rem;
  padding-top: 3rem;
  padding-bottom: 2rem;
}

.app-footer-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media screen and (width <= 46.875rem) {
    flex-flow: column nowrap;
    align-items: center;
  }

  // @media screen and (max-width: 10)
}
.app-footer__col {
  display: flex;
  flex-flow: column nowrap;
}

.app-footer__copyright {
  padding: 1rem 0;
  font-size: 0.875rem;

  @media screen and (width <= 46.875rem) {
    text-align: center;
  }
}

.app-footer__list-item {
  padding: 0 1rem;
  font-size: 0.875rem;

  @media screen and (width <= 46.875rem) {
    padding: 1rem 0;
  }
}

.app-footer__navigation {
  display: flex;
  justify-content: flex-start;
  color: $dark;

  @media screen and (width <= 46.875rem) {
    flex-flow: column nowrap;
    text-align: center;
    justify-content: stretch;
  }

  .app-footer__list-item:first-child {
    padding-left: 0;
  }

  .app-footer__list-item:last-child {
    padding-right: 0;
  }
}
.app-footer__logos-list {
  display: flex;
  flex-flow: row nowrap;
  @media screen and (width <= 46.875rem) {
    flex-flow: column nowrap;
    margin-bottom: 2rem;
  }
}

.app-footer__logo-item {
  max-width: 9.4375rem;
  max-height: 3.9375rem;
  margin: 0 0.5rem;
  &:last-child,
  &:first-child {
    margin: 0;
  }
  img {
    display: block;
    width: auto;
    height: 100%;
    object-fit: contain;
  }
}
.app-footer__logos-title {
  margin-bottom: 0;
  font-size: 0.75rem;
  @media screen and (width <= 46.875rem) {
    text-align: center;
    padding-top: 1.75rem;
  }
}
</style>
